import { render, staticRenderFns } from "./ChangesSaving.Vue?vue&type=template&id=31fced31"
import script from "./ChangesSaving.Vue?vue&type=script&lang=js"
export * from "./ChangesSaving.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/ChangesSaving.Vue
// module id = 238
// module chunks = 0